import { render, staticRenderFns } from "./Capabilities.vue?vue&type=template&id=2acaf392&scoped=true"
import script from "./Capabilities.vue?vue&type=script&lang=js"
export * from "./Capabilities.vue?vue&type=script&lang=js"
import style0 from "./Capabilities.vue?vue&type=style&index=0&id=2acaf392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acaf392",
  null
  
)

export default component.exports